import React from 'react';

import { basicRTEControls } from '../../config/allInteractives';
import makePath from '../../utils/makePath'
import { accentColors } from '../../config/hotspot';

import { ColorPicker, ImageUpload, TextInput, RichTextEditor } from '../EditorFormElements';
import { FormFieldWrapper } from '../Global';

export const Popover = React.memo((props) => {

  const { given = {}, showColorPicker } = props
  const path = makePath(props.path, 'popover')

  return (
    <FormFieldWrapper>

      {showColorPicker ? 
        <ColorPicker 
          label="Accent Color"
          name="accentColor" 
          path={path}
          given={given.accentColor} 
          colors={accentColors}
        />
      : '' }

      <ImageUpload 
        label="Header Image"
        name="icon" 
        path={path}
        tooltip="Upload an image to display above the heading. Image size can not be larger than 110px by 110px or smaller than 80px by 80px, and should not exceed 75KB."
        includeAlt={true} 
        altPlaceholder="Provide header image alt text to support screen readers."
        altLabel="Header Image Alt Text"
        given={given.icon}
        optional
      />

      <TextInput 
        label="Heading"
        defaultText="Enter heading text"
        name="title"
        path={path}
        given={given.title} 
      />

      <TextInput 
        label="Subheading"
        name="subtitle" 
        path={path}
        given={given.subtitle}
        validationCriteria={{
          optional:true
        }}
        help="This field is optional."
      />

      <RichTextEditor 
        // label="Body"
        name="body"
        path={path}
        defaultValue="Enter body text for popover."
        controls={basicRTEControls} 
        given={given.body} 
      /> 
      
    </FormFieldWrapper>
  )

  
})